


import React from 'react';

import CSPSidebar from "../../components/Elements/Sidebars/CSPSidebar";
import Footer from '../../components/Sections/Footer';

export default function CspDashboard() {
  return (
<>
<div className="div"  style={{ minHeight: "100vh"}}>
  <CSPSidebar />
<Footer/>
</div>

</>
  )
}
